<div [formGroup]="form"
     [kalLoading]="loading"
     class="container gup-C-ibanEditDialog"
     kalDialogContent>

    @if (data.shouldDisplayIbansList) {

        <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

            <div class="gup-C-flexGroup__item -demi">
                <kal-form-field>

                    <kal-select [formControl]="ibansListControl"
                                label="Liste des IBANs disponibles"
                                placeholder="Sélectionner un IBAN">
                        @for (ibanTiers of filteredIbansList; track ibanTiers.IdRib) {
                            <kal-option [value]="ibanTiers.IdRib">
                                {{ibanTiers.CodePaysIban}}{{ibanTiers.CleIban}} {{ibanTiers.BBAN}}
                            </kal-option>
                        }

                    </kal-select>

                </kal-form-field>
            </div>

            <div class="gup-C-flexGroup__item -tiers">
                <kal-checkbox [formControl]="showClosedControl"
                              [value]="false"
                              label="Voir les archivés">
                </kal-checkbox>
            </div>

        </div>

    }

    <!-- Banque -->
    <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

        <kal-form-field class="gup-C-flexGroup__item -demi">

            <kal-input (kalAutocompleteSelected)="patchAutocompletedBank($event)"
                       [kalAutocomplete]="autocompleteDataSource"
                       formControlName="bank"
                       icon="keyboard_arrow_down"
                       id="iban_edit_dialog_bank"
                       kalAutocompleteHeight="24vh"
                       label="Banque"
                       placeholder="Banque">
            </kal-input>

        </kal-form-field>

    </div>

    <div class="gup-O-separationLine"></div>

    <!-- IBAN -->
    <h5 class="gup-O-titrage__subTitle">Identifiant international de compte bancaire</h5>

    <div class="gup-C-ibanEditDialog__identinternatCompte">

        <div class="gup-C-flexGroup -row -nowrap -justifyBetween -alignEnd">

            <kal-form-field class="iban gup-C-flexGroup__item">

                <kal-input [errorsMessage]="ibanErrors"
                           formControlName="iban"
                           label="IBAN (International Bank Account Number) "
                           id="iban_edit_dialog_iban">
                </kal-input>

            </kal-form-field>

            <kal-form-field class="bic gup-C-flexGroup__item">

                <kal-input formControlName="bic"
                           id="iban_edit_dialog_bic"
                           label="BIC (Bank Identification Code)">
                </kal-input>

            </kal-form-field>

        </div>

    </div>

    <div class="gup-C-flexGroup -row -justifyStart">

        <kal-form-field class="gup-C-flexGroup__item -demi">

            <kal-input formControlName="ibanAccountOwner"
                       label="Titulaire du compte">
            </kal-input>

        </kal-form-field>

    </div>

    <div class="gup-C-flexGroup -row -justifyStart">

        <kal-form-field class="gup-C-flexGroup__item -demi">

            <kal-input formControlName="ibanOwnerAddressLine1"
                       label="Adresse">
            </kal-input>

        </kal-form-field>

    </div>


    <div class="gup-C-ibanEditDialog__identinternatCompte">

        <div class="gup-C-flexGroup -row -nowrap -justifyBetween -alignEnd">
            <kal-form-field>
                <kal-input formControlName="ibanOwnerPostCode"
                           label="Code Postal"></kal-input>
            </kal-form-field>

            <kal-form-field class="iban gup-C-flexGroup__item">

                <kal-input formControlName="ibanOwnerTown"
                           label="Ville">
                </kal-input>

            </kal-form-field>

        </div>

    </div>

    
    <div class="gup-C-flexGroup -row -justifyStart">

        <kal-form-field class="bic gup-C-flexGroup__item">

            <kal-select formControlName="ibanOwnerCountryCode"
                displaySearchbar
                label="Pays"
                placeholder="Sélectionner un pays"
                disableFirstOptionSelection>
                
                @for(entry of countryMapEntries; track entry[0]) {
                    <kal-option [value]="entry[0]">
                        {{ entry[1] }}
                    </kal-option>
                }

            </kal-select>

        </kal-form-field>

    </div>


    @if (beneficiaryIban) {
        <kal-form-field class="without-label gup-C-flexGroup__item -full">

            <kal-checkbox formControlName="isDefault"
                          label="IBAN par défaut">
            </kal-checkbox>

        </kal-form-field>
    }

    @if (!isIbanCreation) {
        <kal-form-field class="without-label gup-C-flexGroup__item -full">

            <kal-checkbox formControlName="isClosed"
                          id="iban_edit_dialog_is_closed"
                          label="Archiver l'IBAN">
            </kal-checkbox>

        </kal-form-field>
    }

    @if (data.beneficiaryId) {
        <div class="gup-O-separationLine"></div>

        <h5 class="gup-O-titrage__subTitle">Référence Unique de Mandat</h5>

        <kal-form-field>

            <kal-select formControlName="bankAccountId"
                        id="iban_edit_dialog_bank_account"
                        label="Compte bancaire"
                        placeholder="Sélectionner un compte bancaire">

                @for (bankAccount of bankAccountsList; track bankAccount.IdCompteBancaire) {
                    <kal-option [value]="bankAccount.IdCompteBancaire">
                        {{ bankAccount.LibelleCompteBancaire }}
                    </kal-option>
                }

            </kal-select>

            @if (form.get('bankAccountId').value) {
                <a (click)="createMandat()"
                   class="gup-O-link -secondary xmall"
                   id="iban_edit_dialog_add_mandat">
                    Ajouter un mandat
                </a>
            }

        </kal-form-field>

        <kal-table #mandateTable
                   [columns]="columns"
                   [dataSource]="filteredMandateList"
                   formArrayName="mandateList"
                   class="no-action"
                   actionable>

            <tr *kalHeaderRowDef kal-header-row></tr>

            <ng-container kalColumn="NumeroICS">
                <td *kalBodyCell="let row">
                    {{ row.value.NumeroICS }}
                </td>
            </ng-container>

            <ng-container kalColumn="NomCompteBancaire">
                <td *kalBodyCell="let row">
                    {{ row.value.NomCompteBancaire }}
                </td>
            </ng-container>

            <ng-container kalColumn="ReferenceMandat">
                <td *kalBodyCell=" let row; let index = index"
                    [formGroupName]="index">

                    <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">

                        <kal-input #input
                                   formControlName="ReferenceMandat"
                                   (click)="stopPropagation($event)"
                                   (keydown.enter)="input.blur()"
                                   [tabIndex]="index"
                                   (valueChanges)="checkRUMAvailable($event)">
                        </kal-input>

                    </kal-form-field>

                </td>
            </ng-container>

            <ng-container kalColumn="DateValidation">

                <td *kalBodyCell="let row">
                    {{ row.get('DateValidation').value | date:'dd/MM/yyyy' }}
                </td>

            </ng-container>

            <ng-container kalColumn="DateOperation">

                <td *kalBodyCell="let row">
                    {{ row.get('DateOperation').value | date:'dd/MM/yyyy' }}
                </td>

            </ng-container>

            <ng-container [kalColumn]="mandateTable.actionColumnName">

                <td *kalBodyCell="let row">
                    <div>
                        <kal-button [kalMenuTriggerFor]="actionsMenu"
                                    (click)="stopPropagation($event)"
                                    kalTheme="tertiary">
                            <kal-icon>more_horiz</kal-icon>
                        </kal-button>

                        <kal-menu #actionsMenu>
                            <kal-option (selectionChange)="deleteMandat(row.value)">
                                Supprimer
                            </kal-option>
                        </kal-menu>
                    </div>
                </td>

            </ng-container>

        </kal-table>

        @if (hasAttachments) {

            <div class="gup-O-separationLine"></div>

            <h5 class="gup-O-titrage__subTitle">Pièces justificatives</h5>

            <app-shared-voucher *ngFor="let attachment of attachmentListFormArray.controls"
                                disableRemoteCommentSave
                                [formControl]="attachment">
            </app-shared-voucher>

        }
    }
</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="saveIBAN()"
                        [disabled]="form.invalid"
                        id="iban_edit_dialog_submit"
                        kalTheme="primary">
                Valider
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="close()"
                        id="iban_edit_dialog_cancel"
                        kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
